import RequestsProcessor from "@src/Tools/AxiosRequestsProcessor";
import { Theme } from "@src/Interfaces/Entity/Theme";
import { IThemesStore, TypeAppliedTheme } from "./types";
import Stores from "..";
import { action, observable } from "mobx";
import { IApiResponse } from "../../Interfaces/Entity/ApiResponse";

const requestsProcessor: RequestsProcessor = new RequestsProcessor();

class ThemesStore implements IThemesStore {
  defaultApplicationTheme: TypeAppliedTheme = {
    applicationThemeDetails: {
      applicationLogoImageUrl: "",
      applicationLogoImage: null,
      applicationLogoImageId: "",
      primaryColor: "#2e4e5e",
      primaryTextColor: "",
    },
    loginThemeDetails: {
      loginBackgroundLandscapeImage: null,
      loginBackgroundLandscapeImageUrl: "",
      loginBackgroundLandscapeImageId: "",
      loginBackgroundPortraitImageUrl: "",
      loginBackgroundPortraitImage: null,
      loginBackgroundPortraitImageId: "",
      loginLogoImageUrl: "",
      loginLogoImage: null,
      loginLogoImageId: "",
    },
    secondaryColor: "#fafafa",
  };

  @observable
  application: TypeAppliedTheme = {
    ...this.defaultApplicationTheme,
  };

  @observable
  login: TypeAppliedTheme = {
    ...this.defaultApplicationTheme,
  };

  @action.bound
  async getCurrentTheme(type: number, tenant?: string) {
      const response: Theme = Stores.values.isNightTheme ? await this.getTheme(0, type, tenant) : await this.getTheme(1, type, tenant);

    if (response) {
      if (type === Stores.values.themeTypes.Application) {
        this.application = response;
      } else {
        this.login = response;
      }
      this.updateCss(response.css);
    } else {
      this.application = this.defaultApplicationTheme;
      this.updateCss("");
    }
    return response;
  }

  updateCss(css: string) {
    const head = document.getElementsByTagName("HEAD")[0];
    const oldStyle = document.getElementById("themeStyle");
    if (oldStyle) {
      oldStyle.remove();
    }
    const style = document.createElement("style");
    style.type = "text/css";
    style.id = "themeStyle";
    style.innerHTML = css;
    head.appendChild(style);
  }

  @action.bound
  async getTheme(colorType: number, type: number, tenant?: string) {
    let requestUrl = `themes/current?colorType=${colorType}&type=${type}`;
    if (tenant) {
      requestUrl += `&tenant=${tenant}`;
    }

    const response: IApiResponse<Theme> = await requestsProcessor.get<IApiResponse<Theme>>(requestUrl, "GetTheme");
    return response.data;
  }

}

export default ThemesStore;
